<template>
	<div class="page-container">
		<head-top head-title="我的订单" goBack="true"></head-top>

		<div class="order-page">
			<div class="filter-bar flex_a bg_a" @click="showMonthPicker = true">
				<div class="month-text">按年月筛选：{{ selectedYear + '年' + selectedMonth + '月'}}</div>
				<van-icon name="arrow-down" />
			</div>

			<van-tabs v-model="activeTab" animated @change="onTabChange">
				<van-tab title="待结算"></van-tab>
				<van-tab title="已结算"></van-tab>
			</van-tabs>

			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-empty v-if="!loading && finished && orders.length === 0" description="暂无订单" />
				<van-list :offset="40" v-else v-model="loading" :finished="finished" :immediate-check="false"
					:finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
					<div class="order-list">
						<div class="order-item bg_a flex_c" v-for="item in orders" :key="item.id">
							<div class="order-logo">
								<img v-if="item.logo" :src="getImageUrl(item.logo)" />
							</div>
							<div class="order-info">
								<div class="order-brand">{{ item.advertiserDisplayName }}</div>

								<div class="flex_c">
									<div class="order-amount">
										${{ Number(item.amountValue).toFixed(2) }}
									</div>
									<div class="order-time">
										{{ item.eventTimestamp }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>

		<van-popup v-model="showMonthPicker" position="bottom" close-on-popstate safe-area-inset-bottom>
			<van-datetime-picker v-model="currentDate" :max-date="maxDate" type="year-month" title="选择年月"
				:formatter="formatter" @confirm="onMonthConfirm" @cancel="showMonthPicker = false" />
		</van-popup>

		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		getLoginMember,
		getEstimateOrderList,
		getSettlementOrderList,
		imageUrl
	} from '@/apis/api.js'

	export default {
		name: 'MyOrders',
		components: {
			headTop
		},
		data() {
			return {
				currentDate: new Date(),
				selectedYear: new Date().getFullYear(),
				selectedMonth: new Date().getMonth() + 1,
				maxDate: new Date(),
				activeTab: 0,
				orders: [],
				showMonthPicker: false,
				showBackToTop: false,

				pageNum: 0,
				total: 0,
				pageSize: 10,
				loading: false,
				finished: false,
				refreshing: false,
			}
		},
		mounted() {
			if (!getLoginMember()) {
				this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
				return
			}
			this.getList()
			window.addEventListener('scroll', this.handleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			getImageUrl(path) {
				return imageUrl(path)
			},
			formatter(type, val) {
				if (type === 'year') {
					return `${val}年`
				} else if (type === 'month') {
					return `${val}月`
				}
				return val
			},
			onMonthConfirm() {
				this.selectedYear = this.currentDate.getFullYear()
				this.selectedMonth = this.currentDate.getMonth() + 1
				this.showMonthPicker = false
				this.resetAndLoad()
			},
			onTabChange() {
				this.resetAndLoad()
			},
			resetAndLoad() {
				this.pageNum = 0
				this.orders = []
				this.finished = false
				this.loading = true
				this.getList()
			},
			getList() {
				this.pageNum++
				const api = this.activeTab === 0 ? getEstimateOrderList : getSettlementOrderList
				api(this.selectedYear, this.selectedMonth, {
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					.then(res => {
						const rows = res.rows || []
						this.total = res.total || 0
						this.orders = this.orders.concat(rows)
						if (this.orders.length >= this.total) {
							this.finished = true
						} else {
							this.finished = false
						}
					})
					.catch(e => {
						this.finished = true
						if (!e.handled) {
							this.$toast('加载失败')
						}
					})
					.finally(() => {
						this.loading = false
						this.refreshing = false
					})
			},
			onLoad() {
				if (this.refreshing || this.finished) return
				this.getList()
			},
			onRefresh() {
				this.pageNum = 0
				this.orders = []
				this.finished = false
				this.getList()
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.showBackToTop = scrollTop > 300
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.order-page {
			.filter-bar {
				padding: 10px 14px;

				.month-text {
					font-size: 14px;
					color: #333;
					font-weight: bold;
					margin-right: 6px;
				}

				.van-icon {
					font-size: 14px;
					color: #999;
				}
			}

			:deep(.van-tabs__nav) {
				background: transparent;
			}

			:deep(.van-tab) {
				font-size: 14px;
				color: #999;
			}

			:deep(.van-tab--active) {
				color: #333;
				font-weight: bold;
			}

			.order-list {
				padding: 0 14px;

				.order-item {
					padding: 14px;
					border-radius: 8px;
					margin-bottom: 10px;

					.order-logo {
						flex: none;
						width: 50px;
						height: 50px;
						margin-right: 12px;
						background: #fff;
						border-radius: 4px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							object-fit: contain;
						}
					}

					.order-info {
						flex: 1;

						.order-brand {
							width: 100%;
							font-size: 14px;
							font-weight: bold;
							color: #333;
							margin-bottom: 5px;
							word-break: break-all;
						}

						.order-time {
							font-size: 12px;
							color: #999;
						}

						.order-amount {
							font-weight: bold;
							font-size: 12px;
							color: #FF6C22;
						}
					}
				}
			}
		}

		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;

			&.show {
				opacity: 1;
				visibility: visible;
			}

			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}
	}
</style>